export const ADD_OR_REMOVE_TO_DROPBOX = 'ADD_SINGLE_TO_DROPBOX';
export const REMOVE_ALL = 'REMOVE_ALL_DROPBOX_ITEM';
export const DOWNLOAD_ALL = 'DOWNLOAD_ALL_DROPBOX_ITEM';
export const DROPBOX_MODE_ENABLED = 'DROPBOX_MODE_EMABLED';
export const GET_DROPBOX_SONGS = 'GET_DROPBOX_SONGS';
export const UPLOAD_SONGS_TO_DROPBOX = 'UPLOAD_SONGS_TO_DROPBOX';
export const ADD_SONG_ENTITY_TO_DROPBOX = 'ADD_SONG_ENTITY_TO_DROPBOX';


